/// <reference path="../../../../Scripts/typings/moment/moment.d.ts" />
define('areas/organizationmanager/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var OrganizationVM = (function () {
        function OrganizationVM() {
            ko.track(this);
        }
        return OrganizationVM;
    }());
    exports.OrganizationVM = OrganizationVM;
    var NetworkMemberVM = (function () {
        function NetworkMemberVM() {
        }
        return NetworkMemberVM;
    }());
    exports.NetworkMemberVM = NetworkMemberVM;
});

